import ExpandableContent from '@app/components/ExpandableContent'
import PillListRenderer from '@app/components/PillListRenderer'
import { SocialConnection } from '@app/components/SocialConnection'
import { ICurrentUserState } from '@app/store/modules/account'
import { IGlobalSocialNetworksState } from '@app/store/modules/global'
import {
  formatAddressSingleLine,
  formatDate,
  humanize,
} from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, IConnectionViewState } from '../modules/connectionView'

interface IConnectionViewRouterProps {
  id: string
}

type IComponentProps = IConnectionViewState &
  ICurrentUserState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

class ConnectionDetails extends React.PureComponent<IComponentProps> {
  public render() {
    return (
      <div>
        {this.props.item.groups.size > 0 && (
          <h5 className='section-title'>Groups</h5>
        )}
        {this._renderGroups()}
        <h5 className='section-title'>Info</h5>
        {this._renderInfo()}
        <h5 className='section-title'>Public Notes</h5>
        <div className='ml-3 white-space-pre'>
          {this.props.item.note || 'None'}
        </div>
        <h5 className='section-title'>My Notes</h5>
        <div className='ml-3 white-space-pre'>
          {this.props.item.privateNote.note || 'None'}
        </div>
        <h5 className='section-title'>Related Connections</h5>
        {this._renderConnections()}
        <h5 className='section-title'>Properties</h5>
        {this._renderProperties()}
      </div>
    )
  }

  private _renderAddresses() {
    if (!this.props.item.addresses || this.props.item.addresses.size === 0) {
      return null
    }

    return (
      <div>
        {this.props.item.addresses.map((address: any, i) => {
          return (
            <div className='d-flex flex-column' key={`address-${i}`}>
              <div className='d-flex flex-row'>
                <div className='mr-2'>
                  <FontAwesomeIcon
                    className='text-muted'
                    icon={['fal', 'map-marker-alt']}
                    fixedWidth
                  />
                </div>
                {`${humanize(address.type)} - ${formatAddressSingleLine(
                  address,
                )}`}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  private _renderBirthday() {
    return (
      <div className='d-flex flex-row'>
        <div className='mr-2'>
          <FontAwesomeIcon
            className='text-muted'
            icon={['fal', 'gift']}
            fixedWidth
          />
        </div>
        <div>
          {this.props.item.birthday
            ? formatDate(this.props.item.birthday, 'MMMM DD, YYYY')
            : 'No birthday'}
        </div>
      </div>
    )
  }

  private _renderConnections() {
    if (this.props.item.associated && this.props.item.associated.size > 0) {
      return (
        <div className='ml-3'>
          <ExpandableContent>
            <PillListRenderer
              list={this.props.item.associated}
              baseNavigateUrl='/connection'
              idValue='contactId'
            />
          </ExpandableContent>
        </div>
      )
    } else {
      return <div className='ml-3'>None</div>
    }
  }

  private _renderGroups() {
    const items = this.props.item.groups.map((group: any, i) => {
      return <div key={`group-${i}`}>{group.name}</div>
    })

    if (items && items.size > 0) {
      return <div className='ml-3'>{items}</div>
    } else {
      return null
    }
  }

  private _renderInfo() {
    return (
      <div className='d-flex flex-column ml-3'>
        <div className='d-flex flex-row justify-content-between flex-wrap'>
          <div className='d-flex flex-column'>
            {this._renderBirthday()}
            {this._renderWebsiteUrl()}
          </div>
          {this._renderSocialNetworks()}
          {this._renderAddresses()}
        </div>
      </div>
    )
  }

  private _renderProperties() {
    if (this.props.item.properties && this.props.item.properties.size > 0) {
      return (
        <div className='ml-3'>
          <ExpandableContent>
            <PillListRenderer
              list={this.props.item.properties}
              baseNavigateUrl='/properties/property'
              idValue='propertyId'
            />
          </ExpandableContent>
        </div>
      )
    } else {
      return <div className='ml-3'>None</div>
    }
  }

  private _renderSocialNetworks() {
    return (
      <div className='d-flex flex-column justify-content-between flex-wrap'>
        {this.props.item.social.map((s, i) => {
          if (s === undefined || i === undefined) {
            return null
          }

          return <SocialConnection key={`social-${i}`} socialConnection={s} />
        })}
      </div>
    )
  }

  private _renderWebsiteUrl() {
    return (
      <div className='d-flex flex-row'>
        <div className='mr-2'>
          <FontAwesomeIcon
            className='text-muted'
            icon={['fal', 'browser']}
            fixedWidth
          />
        </div>
        <div>
          {this.props.item.url ? (
            <a href={this.props.item.url} target='_blank' rel='noreferrer'>
              {this.props.item.url}
            </a>
          ) : (
            'No website'
          )}
        </div>
      </div>
    )
  }
}

export default withRouter(ConnectionDetails)
